import React from "react";
import { BlueCheckbox } from "../../../../../app/assets/icons";

const NotificationCheckbox = ({checked, disabled, small}) => {
    return (
        <div className={`checkbox-wrapper ${checked ? 'active' : ''} ${small ? 'small' : ''}`}>
            <div className="checkbox-inner">
                <div className="checkbox-line">
                    <img src={BlueCheckbox} alt="blue-checkbox"/>
                </div>
            </div>
        </div>
    )
}

export default NotificationCheckbox